export default {
	name: "RedirectableMixin",

	props: {

		// Either a route object, or an array of "routes" to try, "back" is an acceptable array entry,
		// which will be used if router canGoBack property is true
		redirect: [ Object, Array ]
	},

	methods: {
		doRedirect() {
			if ( !this.redirect ) {
				return;
			}

			const redirects = [].concat( this.redirect || [] );

			for ( let i = 0, len = redirects.length; i < len; i++ ) {
				const redir = redirects[i];

				if ( redir === "back" && this.$router.canGoBack ) {
					return this.$router.back();
				}

				if ( typeof redir === "object" ) {
					return this.$router.push( redir );
				}
			}
		}
	}
};
